export const validateTryOnStep = (profile, config) => {
  return true;
};

export const evaluateFacePose = (landmarks, threshold = 0.15) => {
  const noseBase = landmarks[0],
    noseTip = landmarks[3],
    noseRight = landmarks[4],
    noseLeft = landmarks[8];
  const yaw =
    ((noseLeft.x + noseRight.x) / 2 - noseTip.x) /
    Math.abs(noseLeft.x - noseRight.x);
  const roll =
    noseBase.y == noseTip.y
      ? Infinity
      : (noseBase.x - noseTip.x) / (noseTip.y - noseBase.y);

  if (yaw > threshold || yaw < -threshold) {
    return { valid: false, issue: "yaw" };
  }
  if (roll > threshold || roll < -threshold) {
    return { valid: false, issue: "roll" };
  }
  return { valid: true };
};

export const isFaceFramed = (detection) => {
  const { box, imageWidth, imageHeight } = detection;
  const faceCenterX = box.left + box.width / 2;
  const faceCenterY = box.top + box.height / 2;

  const centerOffsetX = Math.abs(faceCenterX - imageWidth / 2) / imageWidth;
  const centerOffsetY = Math.abs(faceCenterY - imageHeight / 2) / imageHeight;
  if (centerOffsetX > 0.24 || centerOffsetY > 0.3) {
    return false;
  }

  const faceAreaRatio = (box.width * box.height) / (imageWidth * imageHeight);
  const faceHeightRatio = box.height / imageHeight;
  const faceWidthRatio = box.width / imageWidth;
  if (
    faceAreaRatio > 0.72 ||
    faceAreaRatio < 0.14 ||
    faceHeightRatio < 0.3 ||
    faceWidthRatio < 0.24
  ) {
    return false;
  }

  const edgeMargin = 0.035;
  if (
    box.left < imageWidth * edgeMargin ||
    box.top < imageHeight * edgeMargin ||
    box.left + box.width > imageWidth * (1 - edgeMargin) ||
    box.top + box.height > imageHeight * (1 - edgeMargin)
  ) {
    return false;
  }

  return true;
};
